import React from "react";

export default function RtHomeTopBar() {
  return <div></div>;
}
